/** @jsxImportSource @emotion/react */
"use client";
import { Text } from "@packages/ui";
import type { PropsWithChildren } from "react";

type BibleNavSectionHeaderProps = PropsWithChildren<{
  position?: number;
  className?: string;
}>;

export const BibleNavSectionHeader = ({
  children,
  position,
  className = "",
}: BibleNavSectionHeaderProps) => {
  return (
    <Text
      as={"h2"}
      type={"title"}
      size={"l"}
      css={
        position !== undefined && position !== null
          ? { order: position }
          : undefined
      }
      className={className}
    >
      {children}
    </Text>
  );
};
